export default "__VITE_ASSET__B42$Qv80__"